import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

export default function useBreakpointManager() {
  const windowWidth = ref(0);

  const setWidth = () => windowWidth.value = window.innerWidth;
  const smAndDown = computed(() => windowWidth.value < 1000);

  setWidth();
  onMounted(() => {
    window.addEventListener('resize', setWidth);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', setWidth);
  });

  return { smAndDown };
}
